import { render, staticRenderFns } from "./preImgmsg.vue?vue&type=template&id=af5b0ff4&"
import script from "./preImgmsg.vue?vue&type=script&lang=js&"
export * from "./preImgmsg.vue?vue&type=script&lang=js&"
import style0 from "./preImgmsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports